
export {ClayIconSpriteContext} from '@clayui/icon';
import __x__ from '@clayui/icon';export default __x__;